// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__15LM-","App__Header":"App_App__Header__28wmN","RotateDevice":"App_RotateDevice__18GmP"};